// extracted by mini-css-extract-plugin
export default {"title":"back_title__mk65E","info":"back_info__nkcg8","button":"back_button__0iNHC","heading":"back_heading__pln0J"};